import capterra from '@public/images/signup/capterra.webp';
import capterraBestEaseOfUse from '@public/images/signup/Capterra_BestEaseOfUse_2026.svg';
import GetApp from '@public/images/signup/GetApp.webp';
import analyticsHighPerformerEmea from '@public/images/signup/SocialMediaAnalytics_HighPerformer_Winter2026-EMEA.svg';
import highestUserAdoption from '@public/images/signup/SocialMediaListeningTools_HighestUserAdoption_Winter2026.svg';
import leaderEmea from '@public/images/signup/SocialMediaManagement_RegionalLeader_Winter2026-EMEA.svg';
import suitesHighPerformerEmea from '@public/images/signup/SocialMediaSuite_HighPerformer_Winter2026-EMEA.svg';
import softwareadvice from '@public/images/signup/softwareadvice.webp';

export const reassuranceLogos = [
    {
        image: capterra,
        alt: 'Capterra'
    },
    {
        image: softwareadvice,
        alt: 'Software Advice'
    },
    {
        image: GetApp,
        alt: 'GetApp'
    }
];

export const reassuranceLogosAwards = [
    {
        image: analyticsHighPerformerEmea,
        alt: 'Social Media Analytics High Performer EMEA'
    },
    {
        image: highestUserAdoption,
        alt: 'Social Media Listening Tools Highest User Adoption'
    },
    {
        image: leaderEmea,
        alt: 'Social Media Management Regional Leader EMEA'
    },
    {
        image: suitesHighPerformerEmea,
        alt: 'Social Media Suites High Performer EMEA'
    },
    {
        image: capterraBestEaseOfUse,
        alt: 'Capterra Best Ease of Use 2026'
    }
];
